import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'DECIDI COSA FARE',
        description:
            "Premi 'Esporta' per generare i Word o i PDF della tua verifica. Premi 'Salva' per salvare la verifica nell'archivio. Premi 'Elimina' per cancellarla.",
        name: 'CartPageAnchor',
        tutorialName: 'dettaglio-nuova-verifica-docente_pulsantiera'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top',
        xOffset: 5
    }
};
